import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { TrashIcon } from "../../../../ui/icons/trash";
import { WordDocumentIcon } from "../../../../ui/icons/WordDocumentIcon";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import { PopupForm } from "../../../../ui/organisms/popupForm";
import { OptionType } from "../../../../utils";
import { AddedRegisterCreation, AddedRegisterDelete, DownloadRegisterLetter, GetAllAddedRegisters, GetAllTypeRegisters, resetAddedRegisterCreationStatus, resetAddedRegisterDeleteStatus, setAddedRegisterCreationPageNumber, setAddedRegisterCreationTypeRegisterId } from "../slice";

export function EditRegistroRight() {
    const dispatch = useAppDispatch()
    const registerState = useAppSelector(state => state.register)
    const [typeRegisterOptions, setTypeRegisterOptions] = useState<OptionType[]>([])
    const [regToDelete, setRegToDelete] = useState<string | null>(null)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [addedRegisterTypeError, setAddedRegisterTypeError] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetAllTypeRegisters({ page: 0, itemsPerPage: 0 }))
        dispatch(GetAllAddedRegisters({ itemsPerPage: 0, page: 0, businessRegisterId: registerState.getAllAddedRegistersFilters.businessRegisterId }))
    }, [])

    useEffect(() => {
        if (registerState.getAllTypeRegistersStatus === 'successfully' &&
            registerState.getAllTypeRegistersResponse !== undefined
        ) {
            const data = registerState.getAllTypeRegistersResponse.data.map(tr => {
                return {
                    value: tr.id,
                    label: `${tr.name} [${tr.code}]`
                } as OptionType
            })
            setTypeRegisterOptions(data)
        }
    }, [registerState.getAllTypeRegistersStatus])

    useEffect(() => {
        if (registerState.addedRegisterCreationStatus === 'successfully') {
            dispatch(resetAddedRegisterCreationStatus())
            dispatch(setAddedRegisterCreationTypeRegisterId(''))
            dispatch(setAddedRegisterCreationPageNumber(10))
            dispatch(GetAllAddedRegisters({ itemsPerPage: 0, page: 0, businessRegisterId: registerState.getAllAddedRegistersFilters.businessRegisterId }))
        }
    }, [registerState.addedRegisterCreationStatus])

    useEffect(() => {
        if (registerState.addedRegisterDeleteStatus === 'successfully') {
            dispatch(resetAddedRegisterDeleteStatus())
            dispatch(GetAllAddedRegisters({ itemsPerPage: 0, page: 0, businessRegisterId: registerState.getAllAddedRegistersFilters.businessRegisterId }))
        }
    }, [registerState.addedRegisterDeleteStatus])

    return (
        <div className="flex flex-col gap-5 w-full">
            <div className="flex flex-col gap-3">
                <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Registro / Creazione</span>
                <MadfarmStaticSelect
                    customZIndex={9999}
                    label="Tipo di registro"
                    noOptionsMessage=""
                    error={addedRegisterTypeError}
                    errorLabel="Tipologia mancante"
                    placeholder={'Seleziona tipologia...'}
                    options={typeRegisterOptions}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setAddedRegisterCreationTypeRegisterId(value))
                    }}
                    value={registerState.addedRegisterCreationRequest.typeRegisterId}
                />
                <MadfarmStaticSelect
                    customZIndex={9999}
                    label="Numero di pagine"
                    noOptionsMessage=""
                    placeholder={'Seleziona numero di pagine...'}
                    options={Array.from({ length: 50 }, (_, index) => {
                        return { value: String(index + 1), label: String(index + 1) } as OptionType
                    })}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setAddedRegisterCreationPageNumber(Number(newValue)))
                    }}
                    value={String(registerState.addedRegisterCreationRequest.pageNumber)}
                />
                <div className="flex justify-end">
                    <ButtonComponent
                        iconPosition="off"
                        variant='outline'
                        color="blue"
                        label="Aggiungi"
                        size="sm"
                        onClick={() => {
                            if (registerState.addedRegisterCreationRequest.typeRegisterId === "") {
                                setAddedRegisterTypeError(true)
                                return
                            }
                            setAddedRegisterTypeError(false)
                            dispatch(AddedRegisterCreation(registerState.addedRegisterCreationRequest))
                        }}
                    />
                </div>
            </div>

            <div className="border-t border-neutral-200" />

            <div className="flex flex-col gap-3">
                <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Registro / Riepilogo</span>
                {
                    (registerState.getAllAddedRegistersResponse?.data ?? []).length === 0 ? (
                        <div className="text-center text-sm text-neutral-500 py-6">Nessun registro aggiunto</div>
                    ) : (
                        registerState.getAllAddedRegistersResponse?.data.map(ar => (
                            <div key={ar.id} className="rounded-xl border border-emerald-200 bg-emerald-50 p-3">
                                <div className="flex gap-3 items-center">
                                    <div className="flex-1">
                                        <div className="text-left">
                                            <span className="text-base font-semibold text-brandPrimary-700">{ar.progressive}</span>
                                        </div>
                                        <div className="text-left">
                                            <span className="text-sm text-neutral-700">{`${ar.typeRegisterDTO.name} [${ar.typeRegisterDTO.code}] - ${ar.pageNumber} pagine`}</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <button
                                            className="p-1.5 rounded-full border border-neutral-200 bg-white hover:bg-neutral-100 transition-colors"
                                            onClick={() => { dispatch(DownloadRegisterLetter(ar.id)) }}
                                        >
                                            <WordDocumentIcon />
                                        </button>
                                        <button
                                            className="p-2 rounded-full border border-red-200 bg-red-50 hover:bg-red-100 transition-colors"
                                            onClick={() => {
                                                setRegToDelete(ar.id)
                                                setShowAlert(true)
                                            }}
                                        >
                                            <TrashIcon size={18} color="red" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )
                }
            </div>

            {
                (showAlert && regToDelete) && (
                    <PopupForm title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div className="p-6 bg-white flex flex-col gap-6">
                            <p className="text-left text-md font-medium text-neutral-700">
                                Sei sicuro di voler eliminare il registro?
                            </p>
                            <div className="flex justify-end gap-2 pt-2 border-t border-neutral-200">
                                <ButtonComponent
                                    variant="outline"
                                    color="blue"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <ButtonComponent
                                    variant="solid"
                                    color="red"
                                    iconPosition="off"
                                    label="Elimina"
                                    size="md"
                                    onClick={() => {
                                        dispatch(AddedRegisterDelete(regToDelete))
                                        setShowAlert(false)
                                    }}
                                />
                            </div>
                        </div>
                    </PopupForm>
                )
            }
        </div>
    )
}